import { render, staticRenderFns } from "./PageUpload.vue?vue&type=template&id=10559aba&"
import script from "./PageUpload.vue?vue&type=script&lang=js&"
export * from "./PageUpload.vue?vue&type=script&lang=js&"
import style0 from "./PageUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PageUpload.vue"
export default component.exports